var $ = jQuery.noConflict();

$(document).ready(function () {
    var step = '.selector__view';

    $(".view--next").on('click', function (e) {
        e.preventDefault();
        let nextStep = parseInt($(this).closest(step).data('step')) + 1;
        $(this).closest(step).removeClass("selector__view--active");
        $('[data-step="' + nextStep + '"]').addClass("selector__view--active");
    });

    $(".view--back").on('click', function (e) {
        e.preventDefault();
        let prevStep = parseInt($(this).closest(step).data('step')) - 1;
        $(this).closest(step).removeClass("selector__view--active");
        $('[data-step="' + prevStep + '"]').addClass("selector__view--active");
    });

    $(".c-selector-option").on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.c-selector-option--active').removeClass("c-selector-option--active");
        $(this).addClass("c-selector-option--active");
        let value = $(this).data('value');
        $(this).siblings('input').val(value);
        if ($(this).siblings('input').val() !== '') {
            $(this).closest('.selector__view').find('.view--next, .view--submit').prop('disabled', false);
        }
    });
    $(".c-selector-range input").on('change', function (e) {
        e.preventDefault();
        $(this).closest('.selector__view').find('.view--next, .view--submit').prop('disabled', false);
    });

    $("#mattress-selector").on('submit', function (e) {
        e.preventDefault();

        let values = $(this).serializeArray(), 
            filtersObj = {}, 
            reccomendationArea = $('#product-recommendation');

        $(step).css('display', 'none');
        $('.mattress-selector__result').css('display', 'block'); 

        console.log(values);

        $.each(values, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        });  

        let data = {
            action: "mattress_selector_result",
            data: filtersObj,
        }

        jQuery.ajax({
            type: "post",
            dataType: "json",
            url: sealy_ajax_object.ajax_url,
            data: data,
            success: function (data) {
                result = data.html; 
                console.log(data);
            }, 
            error: function (request, status, error) {
				alert(request);
                console.log(request, status, error);
			}
        }).done(function () {
            reccomendationArea.find('.c__loader').removeClass('active');
            reccomendationArea.append(result);
        });

    });


// range input
    const rangeInputs = document.querySelectorAll('input[type="range"]')
    const numberInput = document.querySelector('input[type="number"]')

    function handleInputChange(e) {
        let target = e.target
        if (e.target.type !== 'range') {
            target = document.getElementById('range')
        }
        const min = target.min
        const max = target.max
        const val = target.value

        target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
    }

    rangeInputs.forEach(input => {
        input.addEventListener('input', handleInputChange)
    })


    $("input[data-answer]").on('input', function (e) {
        let val = $(this).val();
        let answer = $(this).data('answer');
        $('#' + answer+' span').each(function(el){
            $(this).removeClass('active');
        });
        $('#' + answer + ' span[data-value=' + val+']').addClass('active');
    });

    // numberInput.addEventListener('input', handleInputChange) // if value goes to input number
});
